<template>
  <div class="container-fluid">
    <div
      class="navbar-dark project-header py-2 px-1 d-flex justify-content-between"
    >
      <div
        class="gantt-title-wrapper"
        @click="$router.back()"
        style="cursor: pointer;"
      >
        <a>
          <img
            class="icon icon-xs"
            src="@/assets/img/icons/svgs/solid/left-arrow.svg"
          />
        </a>

        <span class="align-middle ticket-title__client-name pl-0">Logs</span>
      </div>

      <div class="d-flex align-items-center">
        <!-- <button
          class="btn btn-sm text-white bg-green my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          data-toggle="tooltip"
          data-placement="top"
        >
          2232
        </button> -->
      </div>
    </div>

    <!-- <h4>Active Projects</h4> -->
    <div class="card card-body">
      <div v-if="logs.length>0" class="table-responsive">
        <div>
          <table class="table align-items-center">
            <thead class="thead-light">
              <tr>
                <th scope="col" >Date/Time</th>
                <th scope="col" >User</th>
                <th scope="col">Subject</th>
                <th scope="col" >
                  &nbsp;
                </th>
                
              </tr>
            </thead>
            <tbody class="list">
              <tr v-for="(p, i) in logs" :key="i">
                
                <td class="budget">
                  {{p.payment_date}}
                </td>
                <th scope="row">
                  <div class="media align-items-center">
                    
                    <div class="media-body">
                      <span class="name mb-0 text-sm">{{p.name}}</span>
                    </div>
                  </div>
                </th>

                <td class="budget">
                  {{p.subject}}
                </td>
                
                <!-- <td>
                  <div class="avatar-group">
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Ryan Tompson"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-1.jpg"
                      />
                    </a>
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Romina Hadid"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-2.jpg"
                      />
                    </a>
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Alexander Smith"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-3.jpg"
                      />
                    </a>
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Jessica Doe"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-4.jpg"
                      />
                    </a>
                  </div>
                </td> -->
                

                
                <td>
<button
          class="btn btn-sm text-white bg-danger my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          data-toggle="tooltip"
          @click="onArchieveClicked(p)"
          data-placement="top"
        >
          Clear
        </button>
                </td>
                
                
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h4 v-else>No Logs found </h4>
    </div>

  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import swal from "sweetalert2";
export default {
  props: ["tasks", "project"],
  components: {},
  name: "LogScreen",
  data() {
    return {
      logs: []
    };
  },
  computed: {
    ...mapState("user", ["profile"]),
    
  },
  async mounted() {
    this.refreshRecords()
  },
  

  methods: {
    ...mapActions("user", ["fetchAllLogs"]),
    async refreshRecords() {
      try {
        this.logs = await this.fetchAllLogs('active')
      } catch(e) {
        console.log(e)
        //this.$snack.success("Error fetching activity logs")
      }
    }, 

    async onArchieveClicked(project) {
      try{
          let res = await this.updateProjectArchieveStatus({is_archieved: 1, id: project.id})
          await this.refreshRecords()
      } catch(e) {
          console.log(e)
          this.$snack.success("Error archiving the project")
      }
      
    },

    
   
  }
};
</script>

<style lang="css"></style>

<style lang="scss" scoped></style>
